<template>
    <component :is="layout">
        <router-view />
    </component>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    data () {
        return {
        }
    },
    components: {

    },
    created () {
        this.signinIfRequired()
    },
    updated () {
        this.signinIfRequired()
    },
    methods: {
        signinIfRequired () {
            let url = window.location.toString()
            if (!(localStorage.token) && !(url.includes('signin/sso'))) {
                this.$router.push('/signin')
            }
        }
    },
    computed: {
        layout () {
            if (this.$route.name && !this.$route.meta.layout) {
                return 'default-layout'
            } else {
                return 'empty-layout'
            }
        },
        ...mapGetters({ currentUser: 'currentUser' })
    },
    mounted () {
    }
}
</script>

<style>
:root {
    font-size: 14px;
    font-family: "ViRegular","Helvetica","Arial",sans-serif;
}
</style>
